import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal, Table, TableProps } from "antd";
import { shallowEqual, useSelector } from "react-redux";

import { GoDownload } from "react-icons/go";
import { RxCross2 } from "react-icons/rx";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import "./style.css";
import moment from "moment";




interface PreviewTableProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  tableData:any[]
  selectedDate:any
  onDownload: () => void;
}

const PreviewTable: React.FC<PreviewTableProps> = ({
  isModalOpen,
  setIsModalOpen,
  tableData,
  selectedDate,
  onDownload,
}) => {
  //   const [isModalOpen, setIsModalOpen] = useState(false);

  console.log("preview table.......");
  

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };



  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const previewTablecolumns=
  [
    {
      title: "Code",
      dataIndex: "s_code",
      key: "Code",
      width:150
    },
    {
      title: "Close Date",
      dataIndex: "dt_close_date",
      key: "Close Date",
      width:150,
      render:(value:any)=>{
        console.log("CLOSE DATE",value);
        
        return(
        <span>{value ? moment(value).format("DD MM YYYY") : " "}</span>
      )}
    },
    {
      title: "Date",
      dataIndex: "dt_date",
      key: "Date",
      width:150
  
    },
    {
      title: "Entry Time",
      dataIndex: "dt_entry_time",
      key: "Entry Time",
      width:100
  
    },
    {
      title: "Exit Time",
      dataIndex: "dt_exit_time",
      key: "Exit Time",
      width:100
  
    },
    {
      title: "Expiry Date",
      dataIndex: "dt_expiry_date",
      key: "Expiry Date",
      width:100
  
    },
    {
      title: "Dividend List",
      dataIndex: "j_dividend",
      key: "Dividend List",
      width:150,
      render:(_:any,records:any)=>(
        <>
        {Array.isArray(records.j_dividend)
          ? records.j_dividend.map((item: any, idx: number) => 
              { 
              return <div key={idx}>{JSON.stringify(item)}</div>
            }
            )
          : String(records.j_dividend)}
        </>
      )
    },
    {
      title: "Target/Stoploss List",
      dataIndex: "j_target_stoploss",
      key: "Target/Stoploss List",
      width:200,
      render:(_:any,records:any)=>{
        return(
          <>
          {Array.isArray(records.j_target_stoploss)
            ? records.j_target_stoploss.map((item: any, idx: number) => 
                { const { time, Target, Stoploss } = item;
                return <div key={idx}>time:{String(time)} Target:{String(Target)} Stoploss{String(Stoploss)}</div>
              }
              )
            : String(records.j_target_stoploss)}
        </>
        )
      }
      
  
    },
    {
      title: "Exit Price",
      dataIndex: "n_exit_price",
      key: "Exit Price",
      width:100
  
    },
    {
      title: "P/L",
      dataIndex: "n_pl",
      key: "P/L",
      width:100
  
    },
    {
      title: "P/L (₹)",
      dataIndex: "n_pl_rs",
      key: "P/L (₹)",
      width:100
  
    },
    {
      title: "Return",
      dataIndex: "n_return",
      key: "Return",
      width:100
  
    },
    {
      title: "Return After Cost",
      dataIndex: "n_return_after_cost",
      key: "Return After Cost",
      width:100
  
    },
    {
      title: "Strike Price",
      dataIndex: "n_strike_price",
      key: "Strike Price",
      width:100
  
    },
    {
      title: "Transaction Price",
      dataIndex: "n_transaction",
      key: "Transaction Price",
      width:100
  
    },
    {
      title: "One Day P/L",
      dataIndex: "oneDayPl",
      key: "One Day P/L",
      width:100
  
    },
    {
      title: "One Day Return Percentage",
      dataIndex: "oneDay_return_per",
      key: "One Day Return Percentage",
      width:100
  
    },
    {
      title: "Option Type",
      dataIndex: "s_option_type",
      key: "Option Type",
      width:100
  
    },
    {
      title: "Status",
      dataIndex: "s_status",
      key: "Status",
      width:100
  
    },
    {
      title: "Symbol",
      dataIndex: "s_symbol",
      key: "Symbol",
      width:100
  
    },
    {
      title: "Trade Type",
      dataIndex: "s_trade_type",
      key: "Trade Type",
      width:100
  
    }
  ]


  const backdatedpreviewTablecolumns= 
  [
    {
      title: "Code",
      dataIndex: "identifier",
      key: "Code",
      width:150
    },
    {
      title: "Close Date",
      dataIndex: "trade_close_date",
      key: "Close Date",
      width:150
    },
    {
      title: "Date",
      dataIndex: "dt_date",
      key: "Date",
      width:150
  
    },
    {
      title: "Entry Time",
      dataIndex: "dt_open_time",
      key: "Entry Time",
      width:100
  
    },
    {
      title: "Exit Time",
      dataIndex: "dt_end_time",
      key: "Exit Time",
      width:100
  
    },
    {
      title: "Expiry Date",
      dataIndex: "dt_expiry_date",
      key: "Expiry Date",
      width:100
  
    },
    {
      title: "Dividend List",
      dataIndex: "j_dividend_list",
      key: "Dividend List",
      width:150,
      render:(_:any,records:any)=>(
        <>
        {Array.isArray(records.j_dividend)
          ? records.j_dividend.map((item: any, idx: number) => 
              { 
              return <div key={idx}>{JSON.stringify(item)}</div>
            }
            )
          : String(records.j_dividend ?? [])}
        </>
      )
    },
    {
      title: "Target/Stoploss List",
      dataIndex: "targetStoploss",
      key: "Target/Stoploss List",
      width:200,
      render:(obj:any,_:any)=>{
        
        return(
        <>
        {obj ?
          Object.keys(obj)?.map((item:any)=>{
            for (const [key,value] of Object.entries(obj[item])){
             
               return <span>{`{time: ${item} ${key}: ${value}} `}</span>
            }
        }):<span>{`[]`}</span>
        }
      </>
      )}
  
    },
    {
      title: "Exit Price",
      dataIndex: "exit_price",
      key: "Exit Price",
      width:100
  
    },
    {
      title: "P/L",
      dataIndex: "trade_pl",
      key: "P/L",
      width:100
  
    },
    {
      title: "P/L (₹)",
      dataIndex: "trade_pl_rs",
      key: "P/L (₹)",
      width:100
  
    },
    {
      title: "Return",
      dataIndex: "return_per",
      key: "Return",
      width:100
  
    },
    {
      title: "Return After Cost",
      dataIndex: "return_after_cost",
      key: "Return After Cost",
      width:100
  
    },
    {
      title: "Strike Price",
      dataIndex: "strike_price",
      key: "Strike Price",
      width:100
  
    },
    {
      title: "Transaction Price",
      dataIndex: "n_open_transaction_price",
      key: "Transaction Price",
      width:100
  
    },
    {
      title: "One Day P/L",
      dataIndex: "oneDaypl",
      key: "One Day P/L",
      width:100
  
    },
    {
      title: "One Day Return Percentage",
      dataIndex: "oneDay_return_per",
      key: "One Day Return Percentage",
      width:100
  
    },
    {
      title: "Option Type",
      dataIndex: "option_type",
      key: "Option Type",
      width:100
  
    },
    {
      title: "Status",
      dataIndex: "s_reason",
      key: "Status",
      width:100
  
    },
    {
      title: "Symbol",
      dataIndex: "asset",
      key: "Symbol",
      width:100
  
    },
    {
      title: "Trade Type",
      dataIndex: "trade_type",
      key: "Trade Type",
      width:100
  
    }
  ]

  const finalColumns:any=useCallback(()=>{

    if(selectedDate === null){
      return  []
    }
  
    else if(moment(selectedDate).format("YYYY-MM-DD") === moment(new Date()).format("YYYY-MM-DD")){
      return previewTablecolumns;
    }
    else{
      return backdatedpreviewTablecolumns;
    }
  },[selectedDate])

  




  return tableData?.length > 0 ? (
    <>
      <Modal
        title={`CSV Preview ${selectedDate}`}
        closable
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"80VW"}
        footer={
          <>
            <Button
              type="primary"
              onClick={handleCancel}
              danger
              icon={<RxCross2 size={20} />}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              size="middle"
              onClick={onDownload}
              icon={<GoDownload size={20} />}
            >
              Download
            </Button>
          </>
        }
      >
        <div className="insiderTableDiv">
          <Table<any>
            columns={finalColumns()}
            dataSource={tableData}
            scroll={{ x: 70 * 5, y: 55 * 5 }}
          />
        </div>
      </Modal>
    </>
  ) : (
    <Modal
      title={`CSV Preview ${selectedDate}`}
      closable
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"80VW"}
    >
      <p>No data available</p>
    </Modal>
  );
};

export default memo(PreviewTable);
